export default "__VITE_ASSET__GHeamIgU__"